export const accumulator =
  'M190.5,90.5l50-50-25-25-50,50-25-25v75h75Zm-125,75-50,50,25,25,50-50,25,25v-75h-75Zm150-25h-75v75l25-25,50,50,25-25-50-50Zm-175-125-25,25,50,50-25,25h75v-75l-25,25Z'

export const ACC = accumulator
